import { AuthenticationMessenger, AuthenticationService } from '@dangl/angular-dangl-identity-client';
import { Component, DestroyRef, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DanglIconsConfigService, DanglIconsDirective } from 'ng-dangl-icons';
import { FooterComponent, HeaderComponent } from '@dangl/angular-material-shared';
import { Observable } from 'rxjs';
import { MatDrawerMode } from '@angular/material/sidenav';

import { AppConfigService } from './services/app-config.service';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { version } from './version';

@Component({
  selector: 'da-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderComponent,
    SidenavComponent,
    RouterOutlet,
    DanglIconsDirective,
    FooterComponent,
    AsyncPipe,
    MatSidenavModule,
    MatButtonModule,
    MatIcon
  ]
})
export class AppComponent implements OnInit {
  private authenticationMessenger = inject(AuthenticationMessenger);
  private destroyRef = inject(DestroyRef);
  private danglIconsConfigService = inject(DanglIconsConfigService);
  private authenticationService = inject(AuthenticationService);
  private appConfigService = inject(AppConfigService);

  preReleaseVersion = signal<string>(null);
  preReleaseBuildDate = signal<Date>(null);
  preReleaseLiveSiteLink = signal<string>(null);
  menuOpened = signal(false);
  sideNavMode: MatDrawerMode = 'side';

  isAuthenticated = signal(false);
  username: Observable<string>;
  userIdenticonId: Observable<string>;

  ngOnInit() {
    if (this.appConfigService.getFrontendConfig().environment !== 'Production') {
      this.danglIconsConfigService.setConfig({
        baseUrl: 'https://icons-dev.dangl-it.com'
      });
      this.preReleaseVersion.set(version.informationalVersion);
      this.preReleaseBuildDate.set(version.buildDateUtc);
      this.preReleaseLiveSiteLink.set('https://avacloud-admin.dangl-it.com');
    }

    let isFirstRun = true;
    this.authenticationMessenger.isAuthenticated.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(ia => {
      this.isAuthenticated.set(ia);
      if (!ia) {
        this.menuOpened.set(false);
      }

      if (ia && isFirstRun) {
        this.menuOpened.set(true);
      }

      isFirstRun = false;
    });

    this.username = this.authenticationMessenger.username;
    this.userIdenticonId = this.authenticationMessenger.identiconId;
  }

  toggleMenuButton() {
    this.menuOpened.update(opened => !opened);
  }

  logout() {
    this.authenticationService.logout();
  }
}
